<template>
  <div class="add">
    <header class="headet-title">
      <div class="headet-title-box">充值到dopay钱包</div>
    </header>
    <div style="padding:0px 30px 20px 30px">
      <el-tabs v-model="activeName" type="border-card" @tab-click="handleClick">
        <el-tab-pane label="对公账户充值" name="rechargeB2B">
          <div class="recharge-body" style="padding-left:150px;marginTop:40px">
            <el-form ref="form" :rules="rules" :model="form" label-width="150px">
              <el-form-item label="账户可用余额：">
                <span style="color: red">{{ balance }}</span> 元
              </el-form-item>
              <el-form-item label="付款方式：">
                <el-radio-group v-model="radio" @change="radioChange">
                  <el-radio
                    v-for="item in bankList"
                    :key="item.bankCode"
                    :label="item.bankCode"
                    border
                  >{{ item.bankName }} </el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="充值金额：" prop="amount">
                <el-input
                  v-model="form.amount"
                  placeholder="0.00"
                  type="number"
                  clearable
                  style="width:200px;"
                  @blur="getTotAmount"
                />   元
                <div v-if="maxAmount != null" class="sub-title">
                  本次最多可充值
                  <span style="color: red">{{ maxAmount }}</span>
                  元
                </div>
              </el-form-item>
              <el-form-item label="手续费金额：">
                <el-input v-model="form.fee" style="width:200px;" disabled />元
              </el-form-item>
              <el-form-item label="实际支付金额：">
                <el-input v-model="form.totAmount" style="width:200px;" disabled />元
              </el-form-item>

              <el-form-item label="支付密码">
                <!--<el-input v-model="form.payPassword" show-password placeholder="请输入密码" style="width:200px;" />-->
                <span id="password" />
              </el-form-item>
              <el-form-item class="pb-50">
                <el-button type="primary" :loading="loadingSubmitBut" @click="formSubmit('form')">{{ loadingSubmitButtext }}</el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-tab-pane>
        <el-tab-pane v-if="quickForm.customerType === '8'" label="法人银行卡充值" name="rechargeBankQuick">
          <div class="recharge-body" style="padding-left:246px;">
            <el-form ref="quickForm" :rules="quickRules" :model="quickForm" label-width="100px">
              <el-form-item label="选择银行卡：">
                <el-radio-group v-model="quickRadio" @change="radioChangeQuick">
                  <el-radio
                    v-for="item in quickBankList"
                    :key="item.bankCardId"
                    :label="item.bankCardId"
                    :disabled="item.cardStatus === '02'?true:false"
                    border
                    style="display:block;margin-top: 20px;margin-left:0;"
                  >{{ item.bankName }} 尾号 {{ item.cardNo }}
                  </el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item>
                <el-button class="add-box" @click="add">
                  <i style="color: #498AEA">+</i>
                  <span style="color: #498AEA">添加银行卡</span>
                </el-button>
              </el-form-item>
              <el-form-item label="金额：" prop="amount">
                <el-input
                  v-model="quickForm.amount"
                  style="width:200px;"
                  placeholder="0.00"
                  type="number"
                  clearable
                />
                元
                <div v-if="quickMaxAmount != null" class="sub-title">
                  本次最多可充值
                  <span style="color: red">{{ quickMaxAmount === '' ? 0 : quickMaxAmount }}</span>
                  元
                </div>
              </el-form-item>
              <el-form-item label="支付密码：">
                <span id="password2" />
              </el-form-item>
              <el-form-item class="pb-50">
                <el-button type="primary" :loading="loadingSubmitBut" @click="formSubmitQuick('quickForm')">{{ loadingSubmitButtext }}</el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <el-dialog title="是否充值成功" :visible.sync="dialogFormVisible" :close-on-click-modal="false" width="900px" center>
      <span slot="footer" class="dialog-footer">
        <el-button type="success" @click="rechargeSuccess">充值成功</el-button>
        <el-button type="danger" @click="dialogFormVisible = false">充值失败继续充值</el-button>
      </span>
    </el-dialog>
    <el-dialog title="短信验证码" :visible.sync="dialogFormVisible" :before-close="handleClose" :close-on-click-modal="false" width="400px" center>
      <el-form ref="smsForm" :rules="smsRules" :model="smsForm">
        <el-form-item label="短信验证码" :label-width="'100px'" prop="smsCode">
          <el-input v-model="smsForm.smsCode" autocomplete="off" style="width:200px;" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" :loading="loadingSmsSubmitBut" @click="smsFormSubmit('smsForm')">{{ loadingSmsSubmitButtext }}</el-button>
      </div>
    </el-dialog>
    <input id="lic" type="hidden">
  </div>
</template>
<script>
import { initRechargeB2BApi, submitRechargeB2BApi } from '@/api/dopay/rechargeB2B'
import { initRechargeBankquickApi, submitRechargeBankquickApi, confirmRechargeBankquickApi } from '@/api/dopay/rechargeBankQuick'
import Session from '@/utils/session'
import jQuery from 'jquery'
import pgeditorFn from '@/utils/pgeditor'
const pgeditor = pgeditorFn('_ocx_password', 1, '[0-9]*', '[0-9]{6,6}')
const pgeditor2 = pgeditorFn('_ocx_password2', 2, '[0-9]*', '[0-9]{6,6}')
window.pgeCtrl = pgeditor
import { SelectCertificateOnClick, SignOnClick } from '@/utils/CryptoKit'

export default {
  name: 'RechargeB2B',
  data() {
    const reg = /(^[\d]|^[1-9][\d]*)($|[\.][\d]{0,2}$)/
    var validateAmount = (rule, value, callback) => {
      if (!reg.test(value)) {
        this.form.amount = parseFloat(this.form.amount.replace(/[^\d.]/g, '')).toFixed(2)
      }
      callback()
    }
    var validateMaxAmount = (rule, value, callback) => {
      if (isNaN(value) || value === '' || Number(value) === 0) {
        return callback(new Error('金额不能为空'))
      }
      if (this.maxAmount != null && Number(value) > Number(this.maxAmount)) {
        return callback(new Error('超过单笔最大限额'))
      }
      callback()
    }
    var validateAmountQuick = (rule, value, callback) => {
      if (!reg.test(value)) {
        this.quickForm.amount = parseFloat(this.quickForm.amount.replace(/[^\d.]/g, '')).toFixed(2)
      }
      callback()
    }
    var validateMaxAmountQuick = (rule, value, callback) => {
      if (isNaN(value) || value === '' || Number(value) === 0) {
        return callback(new Error('金额不能为空'))
      }
      if (this.quickMaxAmount != null && Number(value) > Number(this.quickMaxAmount)) {
        return callback(new Error('超过单笔最大限额'))
      }
      callback()
    }
    return {
      initForm: {
        customerId: Session.getItem('customerId'),
        code: Session.getItem('customerCode'),
        customerType: Session.getItem('customerType')
      },
      // 对公充值初始化
      bankList: [],
      rateType: '',
      rate: '',
      minFee: '',
      maxFee: '',
      balance: '0.00',
      // 快捷充值初始化
      quickBankList: [],
      quickRateType: '',
      quickRate: '',
      quickMinFee: '',
      quickMaxFee: '',
      form: {
        customerId: Session.getItem('customerId'),
        amount: '',
        bankCode: '',
        totAmount: '',
        payPassword: '',
        orderSource: '1',
        fee: ''
      },
      quickForm: {
        customerId: Session.getItem('customerId'),
        amount: '',
        bankCode: '',
        totAmount: '',
        payPassword: '',
        customerType: Session.getItem('customerType'),
        orderSource: '1',
        bankCardId: '',
        fee: ''
      },
      activeName: 'rechargeB2B',
      maxAmount: '',
      quickMaxAmount: '',
      radio: '',
      quickRadio: '',
      // 校验规则
      rules: {
        // 校验金额
        amount: [
          {
            required: true,
            trigger: 'blur',
            validator: validateMaxAmount
          },
          {
            trigger: 'change',
            validator: validateAmount
          }
        ]
      },
      quickRules: {
        // 校验金额
        amount: [
          {
            required: true,
            trigger: 'blur',
            validator: validateMaxAmountQuick
          },
          {
            trigger: 'change',
            validator: validateAmountQuick
          }
        ]
      },
      smsForm: {
        customerId: '',
        orderNo: '',
        smsCode: ''
      },
      smsRules: {
        smsCode: [
          {
            required: true,
            trigger: 'blur',
            message: '短信验证码不能为空'
          }
        ]
      },
      loadingSubmitBut: false,
      loadingSubmitButtext: '提交',
      dialogFormVisible: false,
      loadingSmsSubmitBut: false,
      loadingSmsSubmitButtext: '提交'
    }
  },
  created() {
    this.initRechargeB2BPage()
    this.initRechargeBankquickPage()
  },
  mounted() {
    this.handleClick()
  },
  methods: {
    add() {
      if (this.quickForm.customerType === '6') {
        this.$router.push({
          name: 'add'
        })
      } else if (this.quickForm.customerType === '8') {
        this.$router.push({
          name: 'addBus'
        })
      }
    },
    handleClick() {
      this.$nextTick(function() {
        jQuery('#password').html(pgeditor.load())
        jQuery('#lic').val(pgeditor.setLicense())
        pgeditor.pwdClear()
        jQuery('#password2').html(pgeditor2.load())
        jQuery('#lic').val(pgeditor2.setLicense())
        pgeditor2.pwdClear()
      })
    },
    initRechargeB2BPage() {
      const param = Object.assign({}, this.initForm)
      initRechargeB2BApi(param).then(res => {
        this.bankList = res.data.bankList
        this.rateType = res.data.rateType
        this.rate = res.data.rate
        this.minFee = res.data.minFee
        this.maxFee = res.data.maxFee
        this.balance = res.data.amount
        if (this.bankList.length > 0) {
          this.radio = this.bankList[0].bankCode
          this.maxAmount = this.bankList[0].maxAmount
          this.form.bankCode = this.bankList[0].bankCode
        }
      }).catch(error => {
        console.log(error) // 请求失败返回的数据
      })
    },
    initRechargeBankquickPage() {
      const param = Object.assign({}, this.initForm)
      initRechargeBankquickApi(param).then(res => {
        this.quickBankList = res.data.bankList
        this.quickRateType = res.data.rateType
        this.quickRate = res.data.rate
        this.quickMinFee = res.data.minFee
        this.quickMaxFee = res.data.maxFee
        for (var i = 0; i < this.quickBankList.length; i++) {
          if (this.quickBankList[i].cardStatus === '01') {
            if (this.quickRadio.length === 0) {
              this.quickRadio = this.quickBankList[i].bankCardId
              this.quickMaxAmount = this.quickBankList[i].maxAmount
              this.quickForm.bankCode = this.quickBankList[i].bankCode
            }
          }
          this.quickBankList[i].cardNo = this.quickBankList[i].cardNoMask.slice(-4)
        }
        console.log('this.quickMaxAmount:', this.quickMaxAmount)
      }).catch(error => {
        console.log(error) // 请求失败返回的数据
      })
    },
    radioChange(val) {
      for (var i = 0; i < this.bankList.length; i++) {
        if (val === this.bankList[i].bankCode) {
          this.maxAmount = this.bankList[i].maxAmount
          this.form.bankCode = this.bankList[i].bankCode
        }
      }
    },
    radioChangeQuick(val) {
      for (var i = 0; i < this.quickBankList.length; i++) {
        if (val === this.quickBankList[i].bankCardId) {
          this.quickMaxAmount = this.quickBankList[i].maxAmount
          this.quickForm.bankCode = this.quickBankList[i].bankCode
        }
      }
    },
    getTotAmount() {
      var amount = this.form.amount
      if (isNaN(amount)) {
        amount = 0
      }
      if (this.rateType === '02') {
        // 固定金额费率
        this.form.fee = this.rate
      } else if (this.rateType === '01') {
        // 百分比费率
        this.form.fee = amount * this.rate / 100
        if (this.form.fee > this.maxFee) {
          this.form.fee = this.maxFee
        }
        if (this.form.fee < this.minFee) {
          this.form.fee = this.minFee
        }
      }
      // 计算实际支付金额
      this.form.totAmount = Number(amount) === 0 ? 0 : Number(amount) + Number(this.form.fee)
    },
    // 表单提交
    formSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          pgeditor.pwdSetSk('d8mujn26fstqdozzq3iijpsvx71g74du')
          const password = pgeditor.pwdResultSM()
          if (password === '') {
            this.$message({
              message: '请输入支付密码',
              type: 'error'
            })
            return false
          }
          this.form.payPassword = password
          this.loadingSubmitBut = true
          this.loadingSubmitButtext = '提交中...'
          const param = Object.assign({}, this.form)
          param.isCfcaDecrypt = SelectCertificateOnClick()
          param.bankCardId = SignOnClick(this.form.bankCardId).result
          pgeditor.pwdClear()
          submitRechargeB2BApi(param).then(res => {
            // this.dialogFormVisible = true
            if (res.data.urlType === '00') {
              window.open(res.data.url, '_blank')
            } else if (res.data.urlType === '01') {
              if (!!window.ActiveXObject || 'ActiveXObject' in window) {
                // ie
                const resHtml = res.data.url
                document.querySelector('body').innerHTML = resHtml
                document.forms[0].submit()
              } else {
                // chrome
                const routeData = this.$router.resolve({ path: 'OpenPage', query: { htmls: res.data.url }})
                console.log(routeData, 'vvvvvvvvvvvvvvvvv')
                window.open(routeData.href, '_blank')
              }
            }
            this.loadingSubmitBut = false
            this.loadingSubmitButtext = '提交'
          }).catch(error => {
            console.log(error) // 请求失败返回的数据
            this.loadingSubmitBut = false
            this.loadingSubmitButtext = '提交'
          })
        } else {
          return false
        }
      })
    },
    smsFormSubmit(formName) {
      console.log(this.$refs[formName])
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loadingSmsSubmitBut = true
          this.loadingSmsSubmitButtext = '提交中...'
          const param = Object.assign({}, this.smsForm)
          confirmRechargeBankquickApi(param).then(res => {
            this.$message({
              message: '充值成功',
              type: 'success'
            })
            this.$router.push({
              name: 'index'
            })
          }).catch(error => {
            console.log(error) // 请求失败返回的数据
            this.loadingSmsSubmitBut = false
            this.loadingSmsSubmitButtext = '提交'
          })
          this.handleClose()
        } else {
          console.log('-------------error')
          return false
        }
      })
    },
    // 快捷表单提交
    formSubmitQuick(formName) {
      this.quickForm.bankCardId = this.quickRadio
      // 计算费率
      if (this.quickRateType === '02') {
        // 固定金额费率
        this.quickForm.fee = this.rate
      } else if (this.quickRateType === '01') {
        // 百分比费率
        this.quickForm.fee = this.quickForm.amount * this.quickRate / 100
        if (this.quickForm.fee > this.quickMaxFee) {
          this.quickForm.fee = this.quickMaxFee
        }
        if (this.quickForm.fee < this.quickMinFee) {
          this.quickForm.fee = this.quickMinFee
        }
      }
      // 计算实际支付金额
      this.quickForm.totAmount = Number(this.quickForm.amount) + Number(this.quickForm.fee)
      this.$refs[formName].validate((valid) => {
        if (valid) {
          pgeditor2.pwdSetSk('d8mujn26fstqdozzq3iijpsvx71g74du')
          const password2 = pgeditor2.pwdResultSM()
          if (password2 === '') {
            this.$message({
              message: '请输入支付密码',
              type: 'error'
            })
            return false
          }
          this.quickForm.payPassword = password2
          this.loadingSubmitBut = true
          this.loadingSubmitButtext = '提交中...'
          const param = Object.assign({}, this.quickForm)
          const signKeys = ['name', 'idCardNo', 'bankCardNo', 'phone']
          param.isCfcaDecrypt = SelectCertificateOnClick()
          for (const item of signKeys) {
            if (this.quickForm[item]) {
              param[item] = SignOnClick(this.quickForm[item]).result
            }
          }
          submitRechargeBankquickApi(param).then(res => {
            var needSms = res.data.needSms
            // needSms是否需要短信验证码0-需要；1-不需要
            if (needSms === '1') {
              this.$message({
                message: '充值成功',
                type: 'success'
              })
              this.$router.push({
                name: 'index'
              })
            } else {
              this.smsForm.customerId = this.quickForm.customerId
              this.smsForm.orderNo = res.data.orderNo
              // 弹出输入短信验证码弹窗
              this.dialogFormVisible = true
            }
            this.loadingSubmitBut = false
            this.loadingSubmitButtext = '提交'
          }).catch(error => {
            console.log(error) // 请求失败返回的数据
            this.loadingSubmitBut = false
            this.loadingSubmitButtext = '提交'
          })
        } else {
          return false
        }
      })
    },
    rechargeSuccess() {
      this.dialogFormVisible = false
      this.$message({
        message: '充值成功',
        type: 'success'
      })
      this.$router.push({
        name: 'index'
      })
    },
    handleClose() {
      this.$refs['smsForm'].resetFields()
      this.dialogFormVisible = false
    }
  }
}
</script>
<style scoped>
  .headet-title{
      padding:10px 30px 20px 30px;
  }
  .headet-title .headet-title-box{
      font-size:16px;
      padding:10px 0;
      border-bottom:1px solid #DBDDE2;
  }
  .pb-50{
    padding-bottom:50px;
  }
  .recharge-body /v-deep/.el-form-item /v-deep/.ocx_style {
    border: 1px solid #dcdfe6;
    line-height: 40px;
    height: 40px;
    width: 200px;
    border-radius: 4px;
    padding: 0 15px;
  }
</style>
<style>
  #password,
  #password2 {
    height: 40px;
  }
  #password input,
  #password2 input,
  #_ocx_password,
  #_ocx_password2 {
    border: 1px solid #dcdfe6;
    line-height: 40px;
    height: 40px;
    width: 90%;
    border-radius: 4px;
    padding: 0 15px;
  }
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none !important;
    margin: 0;
  }

  input[type="number"] {
    -moz-appearance: textfield;
  }
</style>
